// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__33MWg","remitano-homepage":"Footer_remitano-homepage__bZ7yH"};